exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#planHeader {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n}\r\n\r\ndiv.col-sm-6, div.col-md-3 {\r\n    margin: .25em;\r\n}", ""]);

// exports
